import Vue from "vue";

export const contentService = {
  list,
  getById,
  create,
  update,
  remove,
  download
};

function list(params) {
  return Vue.axios.get("v2/admin/support_materials", { params });
}

function getById(id) {
  return Vue.axios.get(`v2/admin/support_materials/${id}`);
}

function create(payload) {
  const formData = new FormData();

  formData.set("title", payload.title);
  formData.set("description", payload.description);
  formData.set("target", payload.target);

  payload.tags.forEach(tag => {
    formData.append("tags[]", tag);
  });

  payload.targetIds.forEach(id => {
    formData.append("target_ids[]", id);
  });

  payload.files.forEach(file => {
    formData.append("files[]", file);
  });

  return Vue.axios.post("v2/admin/support_materials", formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}

function update(payload) {
  const formData = new FormData();

  formData.set("title", payload.title);
  formData.set("description", payload.description);
  formData.set("target", payload.target);

  if (payload.files.length > 0) {
    payload.files.forEach(file => {
      formData.append("files[]", file);
    });
  }

  if (payload.targetIds.length > 0) {
    payload.targetIds.forEach(id => {
      formData.append("target_ids[]", id);
    });
  }

  payload.tags.forEach(tag => {
    formData.append("tags[]", tag);
  });

  return Vue.axios.patch(`v2/admin/support_materials/${payload.id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}

function remove(id) {
  return Vue.axios.delete(`v2/admin/support_materials/${id}`);
}

function download(id) {
  return Vue.axios.get(`v2/realtor/support_material_zip/${id}`, {
    responseType: "blob",
    headers: {
      Accept: "*/*"
    }
  });
}
